import _get from 'lodash/get';
import { BOOKMARKS } from '@bedrock-rdk/constants';
import { LAYOUT_ENTITIES } from '@bedrock/fido-sdk';
import { BOOKMARKS_PATH } from '../../modules/routes/routes.utils';
import { LOCK_POPUPS_MAP } from './lock.constants';

export const getMappedLockPopup = lockId =>
  LOCK_POPUPS_MAP[lockId] ? LOCK_POPUPS_MAP[lockId] : LOCK_POPUPS_MAP.default;

export const getReason = item => _get(item, 'item.action.target.value_lock.reason');

export const getOriginalTarget = item => _get(item, 'item.action.target.value_lock.originalTarget');

export const getReasonAttributes = item => _get(item, 'action.target.value_lock.reasonAttributes', []);

export const isPlayerLocked = entityType =>
  [LAYOUT_ENTITIES.video, LAYOUT_ENTITIES.audio, LAYOUT_ENTITIES.radio, LAYOUT_ENTITIES.live].includes(entityType);

export const getUnlockPathPrefix = entityType => (isPlayerLocked(entityType) ? '' : 'app/');

export const getNestedOriginalTarget = target => {
  if (target.type === 'layout') {
    const layout = target[`value_${target.type}`];

    return `${getUnlockPathPrefix(layout.type)}${layout.type}/${layout.id}`;
  }

  if (target.type === 'app') {
    const original = target[`value_${target.type}`];

    return original && original.reference === BOOKMARKS ? BOOKMARKS_PATH : null;
  }

  if (target.type === 'lock') {
    return getNestedOriginalTarget(target[`value_${target.type}`].originalTarget);
  }

  return null;
};

export const getDeeplinkFromLock = item => {
  if (!item) {
    return null;
  }

  if (item.video) {
    const { id } = item.video;

    if (!id) {
      return null;
    }

    const path = (window.location.hash || '').replace('#', '');

    if (_get(item.video, 'progress.live')) {
      const entityType = path.startsWith(LAYOUT_ENTITIES.radio) ? LAYOUT_ENTITIES.radio : LAYOUT_ENTITIES.live;

      return `${entityType}/${item.video.id}`;
    }

    const entityType = path.startsWith(LAYOUT_ENTITIES.audio) ? LAYOUT_ENTITIES.audio : LAYOUT_ENTITIES.video;

    return `${entityType}/${id.startsWith('clip_') ? id : `clip_${id}`}`;
  }

  const target = item.target || _get(item, 'action.target');
  if (!target || target.type !== 'lock') {
    return null;
  }

  return getNestedOriginalTarget(target);
};
